var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgWebsite(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 20,
    height: 21,
    viewBox: "0 0 20 21",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M10 18C13.4938 18 16.4296 15.611 17.2631 12.3775M10 18C6.50619 18 3.57035 15.611 2.73692 12.3775M10 18C12.0711 18 13.75 14.6421 13.75 10.5C13.75 6.35786 12.0711 3 10 3M10 18C7.92893 18 6.25 14.6421 6.25 10.5C6.25 6.35786 7.92893 3 10 3M10 3C12.8043 3 15.2492 4.53912 16.5359 6.81871M10 3C7.19567 3 4.75083 4.53912 3.4641 6.81871M16.5359 6.81871C14.7831 8.33366 12.4986 9.25 10 9.25C7.50143 9.25 5.21689 8.33366 3.4641 6.81871M16.5359 6.81871C17.1497 7.90619 17.5 9.16219 17.5 10.5C17.5 11.1483 17.4177 11.7774 17.2631 12.3775M17.2631 12.3775C15.1111 13.5706 12.6349 14.25 10 14.25C7.36509 14.25 4.88885 13.5706 2.73692 12.3775M2.73692 12.3775C2.58226 11.7774 2.5 11.1483 2.5 10.5C2.5 9.16219 2.85027 7.90619 3.4641 6.81871",
    stroke: "currentColor",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgWebsite);
export default __webpack_public_path__ + "static/media/website.1f86f4be62058fbb96b86db392af3a82.svg";
export { ForwardRef as ReactComponent };